import { API_CONFIGURACION } from "config/general/Configuracion";
import { SESION } from "config/general/Configuracion";
import {
  API_CUENTA,
  HEADERS,
  CORREO_USUARIO,
} from "config/general/Configuracion";

class ApiClient {
  constructor() {
    this.url = API_CUENTA;
    this.configuracionURL = API_CONFIGURACION
  }

  listarCuentaUsuario = () => {
    let respuesta = {
      method: "get",
      url: `${this.url}/v1/cuenta/listado/${encodeURIComponent(
        localStorage[CORREO_USUARIO]
      )}`,
      headers: HEADERS(),
    };
    return respuesta;
  };

  listarCuenta = (paginacion) => {

    var query = "limite=" + encodeURIComponent(paginacion.limite);
    query += "&actual=" + encodeURIComponent(paginacion.actual);
    if (paginacion.filtro) {
      query += "&filtro=" + encodeURIComponent(paginacion.filtro);
    }
    if (paginacion.orden) {
      query += "&orden=" + encodeURIComponent(paginacion.orden);
    }
    if (paginacion.sentido) {
      query += "&sentido=" + encodeURIComponent(paginacion.sentido);
    }
    let respuesta = {
      method: "get",
      url: `${this.url}/v1/cuenta/listado?${query}`,
      headers: HEADERS(),
    };
    return respuesta;
  };

  grabarCuenta = (cuenta) => {

    let respuesta = {
      method: "post",
      url: `${this.url}/v1/cuenta/cuenta`,
      headers: HEADERS(),
      data: cuenta,
    };
    return respuesta;
  };

  listarMaxPlacaExenta = (cuenta) => {
    let respuesta = {
      method: "get",
      url: `${this.configuracionURL}/v1/configuracion/limite_placa_exenta/${cuenta}`,
      headers: HEADERS(),
    };
    return respuesta;
  };

  listarMaxZonas = (cuenta) => {
    let respuesta = {
      method: "get",
      url: `${this.configuracionURL}/v1/configuracion/limite_max_zonas/${cuenta}`,
      headers: HEADERS(),
    };
    return respuesta;
  };

  listarMaxPerfilesAdministrador = (cuenta) => {
    let respuesta = {
      method: "get",
      url: `${this.configuracionURL}/v1/configuracion/limite_max_perfiles_administrador/${cuenta}`,
      headers: HEADERS(),
    };
    return respuesta;
  };

  listarMaxPerfilesSupervisor = (cuenta) => {
    let respuesta = {
      method: "get",
      url: `${this.configuracionURL}/v1/configuracion/limite_max_perfiles_supervisor/${cuenta}`,
      headers: HEADERS(),
    };
    return respuesta;
  };

  listarMaxPerfilesAuxiliar = (cuenta) => {
    let respuesta = {
      method: "get",
      url: `${this.configuracionURL}/v1/configuracion/limite_max_perfiles_auxiliar/${cuenta}`,
      headers: HEADERS(),
    };
    return respuesta;
  };

  listarMaxPerfilesPromotor = (cuenta) => {
    let respuesta = {
      method: "get",
      url: `${this.configuracionURL}/v1/configuracion/limite_max_perfiles_promotor/${cuenta}`,
      headers: HEADERS(),
    };
    return respuesta;
  };

  listarMaxPerfilesMunicipio = (cuenta) => {
    let respuesta = {
      method: "get",
      url: `${this.configuracionURL}/v1/configuracion/limite_max_perfiles_municipio/${cuenta}`,
      headers: HEADERS(),
    };
    return respuesta;
  };

  listarMaxPerfilesVisor = (cuenta) => {
    let respuesta = {
      method: "get",
      url: `${this.configuracionURL}/v1/configuracion/limite_max_perfiles_visor/${cuenta}`,
      headers: HEADERS(),
    };
    return respuesta;
  };


  grabarLimitePlacaExenta = (cuenta, valor) => {
    let respuesta = {
      method: "put",
      url: `${this.configuracionURL}/v1/configuracion/limite_placa_exenta/${cuenta}/${valor}`,
      headers: HEADERS(),
    };
    return respuesta;
  };

  grabarLimiteMaxZonas = (cuenta, valor) => {
    let respuesta = {
      method: "put",
      url: `${this.configuracionURL}/v1/configuracion/limite_max_zonas/${cuenta}/${valor}`,
      headers: HEADERS(),
    };
    return respuesta;
  };

  grabarLimiteMaxPerfilesAdministrador = (cuenta, valor) => {
    let respuesta = {
      method: "put",
      url: `${this.configuracionURL}/v1/configuracion/limite_max_perfiles_administrador/${cuenta}/${valor}`,
      headers: HEADERS(),
    };
    return respuesta;
  };

  grabarLimiteMaxPerfilesSupervisor = (cuenta, valor) => {
    let respuesta = {
      method: "put",
      url: `${this.configuracionURL}/v1/configuracion/limite_max_perfiles_supervisor/${cuenta}/${valor}`,
      headers: HEADERS(),
    };
    return respuesta;
  };

  grabarLimiteMaxPerfilesAuxiliar = (cuenta, valor) => {
    let respuesta = {
      method: "put",
      url: `${this.configuracionURL}/v1/configuracion/limite_max_perfiles_auxiliar/${cuenta}/${valor}`,
      headers: HEADERS(),
    };
    return respuesta;
  };

  grabarLimiteMaxPerfilesMunicipio = (cuenta, valor) => {
    let respuesta = {
      method: "put",
      url: `${this.configuracionURL}/v1/configuracion/limite_max_perfiles_municipio/${cuenta}/${valor}`,
      headers: HEADERS(),
    };
    return respuesta;
  };

  grabarLimiteMaxPerfilesVisor = (cuenta, valor) => {
    let respuesta = {
      method: "put",
      url: `${this.configuracionURL}/v1/configuracion/limite_max_perfiles_visor/${cuenta}/${valor}`,
      headers: HEADERS(),
    };
    return respuesta;
  };

  grabarLimiteMaxPerfilesPromotor = (cuenta, valor) => {
    let respuesta = {
      method: "put",
      url: `${this.configuracionURL}/v1/configuracion/limite_max_perfiles_promotor/${cuenta}/${valor}`,
      headers: HEADERS(),
    };
    return respuesta;
  };


}
const CuentaApi = new ApiClient();
export default CuentaApi;
